export default __webpack_public_path__ + "static/media/ibiza.ad800bc2.jpg";